










































































import Vue from "vue";
import Page from "@/components/Page.vue";
import eventBus from "@/services/eventBus";

import store, { MetRiportStore } from "../services/MetRiportStore";
import MetRiportHeadEdit from "../components/MetRiportHeadEdit.vue";
import MetRiportItemsEdit from "../components/MetRiportItemsEdit.vue";
import MetRiportExportsList from "../components/MetRiportExportsList.vue";
import { MetRiportItemDefaultProps } from "../models/MetRiportItem";

interface Data {
    store: MetRiportStore;
    valid: boolean;
    validItem: boolean;
}

interface Methods {
    createExport(): void;
    updateHead(): void;
    createItem(): void;
    showNotMappedCodes(): void;
}

    export default Vue.extend<Data, Methods, {}, {}>({
    components: {
        Page,
        MetRiportHeadEdit,
        MetRiportItemsEdit,
        MetRiportExportsList,
    },

    data() {
        return {
            store,
            valid: true,
            validItem: true,
        };
    },

    methods: {
        createExport(): void {
            this.$router.push(`/met-riport/${this.store.metRiportHead.id}/export/create`);
        },
        updateHead(): void {
            store.updateMetRiportHead();
        },
        createItem(): void {
            eventBus.$emit(`MetRiportItemApiSearch:add-item`, {...MetRiportItemDefaultProps, metisHead: Number(this.store.metRiportHead.id), inEdit: true, mapped: true }); //Bővítjük az ApiSearchPage items obj[] -át
        },
        showNotMappedCodes() {
            this.store.showNotMappedCodes = !this.store.showNotMappedCodes;
            ((this.$refs.metRiportItemsEdit as any).$refs.metRiportItemApiSearch as any).refreshClick();
        },
    },
});
